import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";
import { formatDateTime } from "../../../../common/Validations";

const ViewReason = (props) => {
  //const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  // const handleClose = () => {
  //   setOpen(false);
  // };
  // const handleOpen = (data) => {
  //   setOpen(true);
  // };
  const columnsData = [
    {
      name: t("msg_master_list.msg_reason.code"),
      selector: (row) => row.reasonCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reasonCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_reason.reason_name"),
      selector: (row) => row.reasonName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reasonName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.related_departments"),
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.reasonStatus === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.reasonStatus === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.reasonStatus
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row?.createdDate)}{" "}
          </p>
        </div>
      ),
      center: true,
      width: "200px",
    },
  ];
  const { onHide } = props;
  // console.log(">>>>>>>>>", props);
  return (
    <Modal
      {...props}
      onHide={onHide}
      animation={false}
      dialogClassName="modal-90w"
      backdrop="static"
    >
      <ModalHeader
        title={` ${t("msg_master_list.msg_jobstatus.reason_details")} - ${
          props.jobstatusCode
        } `}
      ></ModalHeader>
      <ModalBody>
        <MasterList
          columnsData={columnsData}
          rowsData={props.rowsData?.data}
          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
          pagination
          selectableRows
          handleClose
          cardHeader={false}
          //handleOpen={handleOpen}
          //handleDelete={confirmBeforeDelete}
          //onSelectedRowsChange={handleRowSelected}
        />
      </ModalBody>
    </Modal>
  );
};

export default ViewReason;
